























import {
  createComponent,
  inject,
  onMounted,
  computed
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyRecruitmentKey from "@/components/company-recruitment-key";
import router from '../../../router';
import FormHeader from '../../molecules/FormHeader.vue'

export default createComponent({
  setup() {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
       const companyRecruitment = inject(CompanyRecruitmentKey);
    if (!companyRecruitment) {
      throw new Error(`${CompanyRecruitmentKey} is not provided`);
    }

    const dialog = computed(() => displayui.dialogUpdateJobDraft);
    const openDialog = computed(() => displayui.openDialogUpdateJobDraft);
    const closeDialog = () => {
      displayui.closeDialogUpdateJobDraft()
      companyRecruitment.changeJobDetailFeeFlag()
    }
    const updateJobInfor =  async() => {
    const updateJob = await companyRecruitment.addJobDuplicate(0) as any
      if(updateJob){
        await displayui.openDialogRecruitmentError();
        await companyRecruitment.changeJobDetailFeeFlag()
      } else {
        displayui.closeDialogUpdateJobDraft()
        router.push('/company_offer',() => {})
      }
    }

    return {
      dialog,
      openDialog,
      closeDialog,
      updateJobInfor
    };
  },

  components : {
    FormHeader,
  },
})
